export const BASE_PROFESIONAL = "/profesional";
export const BASE_INICIO = "/inicio";

export const LEGACY_INICIO_REDIRECTS = [
  { from: "hub", to: "hub_familiar", deprecatedSince: "2026-03-19", removeAfter: "2026-06-30" },
  { from: "gestion_familiar", to: "hub_familiar", deprecatedSince: "2026-03-19", removeAfter: "2026-06-30" },
  { from: "personas_a_cargo", to: "hub_familiar", deprecatedSince: "2026-03-19", removeAfter: "2026-06-30" },
  { from: "vincular_cuenta", to: "solicitar_vinculacion", deprecatedSince: "2026-03-19", removeAfter: "2026-06-30" },
  { from: "alta_paciente", to: "solicitar_paciente", deprecatedSince: "2026-03-19", removeAfter: "2026-06-30" },
];
